<template>
  <div
    v-bind:class="{
      'header-icon': true,
      rounded: !label,
      disabled,
      'no-icon': !src,
      'not-interactive': !onClick,
      'icon-rounded': iconRounded,
      'not-filled': notFilled
    }"
    @click="onClick"
    @touchstart="e => e.stopPropagation()"
    @mousedown="e => e.stopPropagation()"
  >
    <div v-if="showEditorPin" class="header-icon-pin" />
    <span
      v-if="src"
      class="icon"
      :style="{ height: `${iconSize}px`, width: `${iconSize}px` }"
      ><img v-bind:src="src" :style="{ height: `${iconSize}px`, width: 'auto' }"
    /></span>
    <span v-if="label" class="label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "HeaderIcon",

  props: {
    iconSize: {
      type: Number,
      default: 24
    },
    showEditorPin: Boolean,
    disabled: Boolean,
    iconRounded: Boolean,
    notFilled: Boolean,
    label: String,
    src: String,
    onClick: {
      type: Function,
      default: () => null
    }
  }
};
</script>

<style scoped>
.header-icon {
  position: relative;
  min-width: 32px;
  min-height: 32px;
  padding: 0 10px;
  background: #2A3F4C;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.5s;
  cursor: pointer;
}
.header-icon-pin {
  width: 8px;
  height: 8px;
  position: absolute;
  top: 0;
  right: 0;
  background: limegreen;
  border-radius: 50%;
}
.header-icon.disabled {
  cursor: default;
  opacity: 0.5;
}
.header-icon.not-interactive {
  cursor: default;
}

.header-icon.icon-rounded .icon {
  border-radius: 50%;
  overflow: hidden;
}
.header-icon.not-filled {
  background: transparent;
}
.header-icon.icon-rounded:hover {
  background: transparent;
}
.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 6px;
}
.label {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #fff;
}

.rounded {
  padding: 0;
  border-radius: 50%;
}
.rounded .icon {
  margin-right: 0;
}

@media (hover: hover) {
  .header-icon:not(.not-interactive):not(.not-filled):hover {
    background: #5c6d79;
  }
}
</style>
